module.exports = __webpack_public_path__ + "assets/561b6a5703c8bd0218569525f0e8113d.mp4";